'use client'

import { ArticleByline, ArticleCategory, ArticleMedia } from '@/components/common/Article'
import { ErrorBlock } from '@/components/common/ErrorBlock'
import { usePage } from '@/components/providers/PageProvider'

import styles from './ArticlePageHeading.module.scss'

export const ArticlePageHeading = () => {
  const { page } = usePage()
  const article = page?.article

  if (!article) return <ErrorBlock />

  const { author, category, date, excerpt, title } = article

  return (
    <div className={styles.container}>
      <div className={styles.info}>
        <ArticleCategory category={category} />
        <h1 className={styles.title} dangerouslySetInnerHTML={{ __html: title }} />
        <ArticleByline author={author} date={date} />
        {excerpt && <p className={styles.excerpt} dangerouslySetInnerHTML={{ __html: excerpt }} />}
      </div>
      <div className={styles.media}>
        <ArticleMedia article={article} />
      </div>
    </div>
  )
}
